"use strict";
// console.log('[PRT] prtconfig', window.PRT_CONFIG);
// ===== BOT DETECTION LIBRARY =====
// Extracted from tt_heimdall_original.js
(() => {
  var e,
    r,
    a,
    t = Object.getOwnPropertyNames,
    o = (e, r) =>
      function () {
        return e && (r = (0, e[t(e)[0]])((e = 0))), r;
      },
    s = o({
      "src/pattern.ts"() {
        e =
          " daum[ /]| deusu/| yadirectfetcher|(?:^|[^g])news(?!sapphire)|(?<! (?:channel/|google/))google(?!(app|/google| pixel))|(?<! cu)bots?(?:\\b|_)|(?<!(?:lib))http|(?<![hg]m)score|@[a-z][\\w-]+\\.|\\(\\)|\\.com\\b|\\btime/|^<|^[\\w \\.\\-\\(?:\\):]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)|^[^ ]{50,}$|^\\d+\\b|^\\w*search\\b|^\\w+/[\\w\\(\\)]*$|^active|^ad muncher|^amaya|^avsdevicesdk/|^biglotron|^bot|^bw/|^clamav[ /]|^client/|^cobweb/|^custom|^ddg[_-]android|^discourse|^dispatch/\\d|^downcast/|^duckduckgo|^facebook|^getright/|^gozilla/|^hobbit|^hotzonu|^hwcdn/|^jeode/|^jetty/|^jigsaw|^microsoft bits|^movabletype|^mozilla/5\\.0\\s[a-z\\.-]+$|^mozilla/\\d\\.\\d \\(compatible;?\\)$|^mozilla/\\d\\.\\d \\w*$|^navermailapp|^netsurf|^offline|^owler|^php|^postman|^python|^rank|^read|^reed|^rest|^rss|^snapchat|^space bison|^svn|^swcd |^taringa|^thumbor/|^track|^valid|^w3c|^webbandit/|^webcopier|^wget|^whatsapp|^wordpress|^xenu link sleuth|^yahoo|^yandex|^zdm/\\d|^zoom marketplace/|^{{.*}}$|adscanner/|analyzer|archive|ask jeeves/teoma|bit\\.ly/|bluecoat drtr|browsex|burpcollaborator|capture|catch|check\\b|checker|chrome-lighthouse|chromeframe|classifier|cloudflare|convertify|crawl|cypress/|dareboost|datanyze|dejaclick|detect|dmbrowser|download|evc-batch/|exaleadcloudview|feed|firephp|functionize|gomezagent|headless|httrack|hubspot marketing grader|hydra|ibisbrowser|images|infrawatch|insight|inspect|iplabel|ips-agent|java(?!;)|jsjcw_scanner|library|linkcheck|mail\\.ru/|manager|measure|neustar wpm|node|nutch|offbyone|optimize|pageburst|pagespeed|parser|perl|phantomjs|pingdom|powermarks|preview|proxy|ptst[ /]\\d|reputation|resolver|retriever|rexx;|rigor|rss\\b|scanner\\.|scrape|server|sogou|sparkler/|speedcurve|spider|splash|statuscake|supercleaner|synapse|synthetic|tools|torrent|trace|transcoder|url|virtuoso|wappalyzer|webglance|webkit2png|whatcms/|zgrab";
      },
    });
  function c(t) {
    return (
      Boolean(t) &&
      (function () {
        if (a instanceof RegExp) return a;
        try {
          a = new RegExp(e, "i");
        } catch (e) {
          a = r;
        }
        return a;
      })().test(t)
    );
  }
  var i,
    n,
    l = o({
      "src/index.ts"() {
        s(), (r = /bot|crawl|http|lighthouse|scan|search|spider/i);
      },
    });
  ((i = {
    "src/browser.ts"() {
      l(),
        "object" != typeof globalThis
          ? "object" != typeof window
            ? "object" != typeof global
              ? "object" == typeof self && (self.isBot = c)
              : (global.isBot = c)
            : (window.isBot = c)
          : (globalThis.isBot = c);
    },
  }),
    function () {
      return n || (0, i[t(i)[0]])((n = { exports: {} }).exports, n), n.exports;
    })();
})();

// ===== ROUTER CONFIGURATION =====

// Configuration - Easy to modify for different domains
var ROUTER_CONFIG = {
  // Domain configuration
  MAIN_DOMAIN: "wellversed.in",
  ALTERNATE_DOMAIN: "store.wellversed.in",
  COOKIE_DOMAIN: ".wellversed.in",
  
  // Traffic split configuration
  TRAFFIC_SPLIT_PERCENTAGE: window.PRT_CONFIG.TRAFFIC_SPLIT_PERCENTAGE, // traffic to alternate domain
  
  // Session configuration
  SESSION_TTL_DAYS: 90,
  
  // Router settings
  ROUTE_BOTS_TO_MAIN: true, // Route bots to main domain (Shopify)
  VERSION: 2
};

// console.log("[PRT], ROUTER_CONFIG", ROUTER_CONFIG);

// Cookie names
var SESSION_DEST_COOKIE = "_prima_session_dest_1";
var SESSION_VERSION_COOKIE = "_prima_session_ver_1";

// Destinations
var DEST_MAIN = "main";
var DEST_ALTERNATE = "alternate";

// Shopify routes that should always go to main domain
var SHOPIFY_ROUTES = new Set([
  "/pages/cancellations-and-refunds",
  "/pages/terms-and-conditions",
  "/pages/privacy-policy",
  "/pages/returns",
  "/pages/contact-us",
  "/pages/shipping-policy",
  "/pages/loyalty-point",
  "/pages/faqs",
  "/pages/review",
  "/blogs",
  "/cdn/shop",
  "/cart.js",
  "/cart",
  "/widget",
  "/api/redirect-hit",
  "/_t/c",
  "robots.txt",
  ".mp4",
  ".js",
  ".css",
  ".json",
  ".html",
  ".png",
  ".jpeg",
  ".jpg",
  ".webp",
  "sitemap",
  "/account",
  "/checkouts",
  "/orders"
]);

// ===== UTILITY FUNCTIONS =====

function isEmptyStr(value) {
  return value == null || (typeof value === "string" && value.trim().length === 0);
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "expires=" + date.toUTCString() + ";";
  }
  
  // Build secure cookie string with security attributes
  // Note: HttpOnly removed because client-side router needs to read cookies
  var cookieStr = name + "=" + encodeURIComponent(value || "") + "; " +
                  expires +
                  " domain=" + ROUTER_CONFIG.COOKIE_DOMAIN +
                  "; path=/;" +
                  " Secure;" +                    // Only transmitted over HTTPS
                  " SameSite=Strict;";           // Prevent cross-site request inclusion
  
  document.cookie = cookieStr;
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0)
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

function checkIfMobile(userAgent) {
  return (
    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(userAgent) ||
    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(userAgent)
  );
}

function isShopifyRoute(path) {
  if (SHOPIFY_ROUTES.has(path)) {
    return true;
  }
  
  var pathsArr = Array.from(SHOPIFY_ROUTES);
  for (let i = 0; i < pathsArr.length; i++) {
    var pathItem = pathsArr[i];
    if (path.startsWith(pathItem) || path.indexOf(pathItem) !== -1) {
      return true;
    }
  }
  return false;
}

function generateRedirectUrl(destination) {
  var currentUrl = new URL(window.location.href);
  var targetDomain = destination === DEST_ALTERNATE ? ROUTER_CONFIG.ALTERNATE_DOMAIN : ROUTER_CONFIG.MAIN_DOMAIN;
  
  // Replace the domain while keeping everything else the same
  var redirectUrl = currentUrl.protocol + "//" + targetDomain + currentUrl.pathname + currentUrl.search + currentUrl.hash;
  return redirectUrl;
}

function getSessionDestination() {
  var sessionDest = getCookie(SESSION_DEST_COOKIE);
  var sessionVersion = getCookie(SESSION_VERSION_COOKIE);
  
  // Check if session is valid and current version
  if (!isEmptyStr(sessionDest) && parseInt(sessionVersion) === ROUTER_CONFIG.VERSION) {
    return sessionDest;
  }
  
  return null;
}

function setSessionDestination(destination) {
  setCookie(SESSION_DEST_COOKIE, destination, ROUTER_CONFIG.SESSION_TTL_DAYS);
  setCookie(SESSION_VERSION_COOKIE, ROUTER_CONFIG.VERSION.toString(), ROUTER_CONFIG.SESSION_TTL_DAYS);
}

// ===== MAIN ROUTER LOGIC =====

try {
  console.log("[PRT] Starting router logic");
  
  var currentPath = window.location.pathname.replace(/\/$/, "").toLowerCase();
  var userAgent = window.navigator.userAgent;
  var isMobile = checkIfMobile(userAgent);
  var isBot = window.isBot && window.isBot(userAgent);
  
  console.log("[PRT] Path:", currentPath, "Mobile:", isMobile, "Bot:", isBot);
  
  // Check if this is a Shopify route that should always stay on main domain
  if (isShopifyRoute(currentPath)) {
    console.log("[PRT] Shopify route detected, staying on main domain");
    // Don't redirect, stay on current domain
  } else if (isBot && ROUTER_CONFIG.ROUTE_BOTS_TO_MAIN) {
    // Route bots to main domain (Shopify) if configured
    console.log("[PRT] Bot detected, routing to main domain");
    setSessionDestination(DEST_MAIN);
    // Don't redirect bots, let them stay on main domain
  } else {
  
  // Check existing session destination
  var sessionDestination = getSessionDestination();
  
  var finalDestination;
  
  if (sessionDestination) {
    // Use existing session destination for consistency
    finalDestination = sessionDestination;
    console.log("[PRT] Using existing session destination:", finalDestination);
  } else {
    // New session - determine destination based on traffic split
    var random = Math.random() * 100;
    
    if (random < ROUTER_CONFIG.TRAFFIC_SPLIT_PERCENTAGE) {
      finalDestination = DEST_ALTERNATE;
    } else {
      finalDestination = DEST_MAIN;
    }
    
    // Set session destination for consistency
    setSessionDestination(finalDestination);
    console.log("[PRT] New session, assigned destination:", finalDestination, "Random:", random);
  }
  
  // Check if we need to redirect
  var currentDomain = window.location.hostname;
  var shouldRedirect = false;
  var redirectUrl = "";
  
  if (finalDestination === DEST_ALTERNATE && currentDomain === ROUTER_CONFIG.MAIN_DOMAIN) {
    // Should be on alternate domain but currently on main domain
    shouldRedirect = true;
    redirectUrl = generateRedirectUrl(DEST_ALTERNATE);
  } else if (finalDestination === DEST_MAIN && currentDomain === ROUTER_CONFIG.ALTERNATE_DOMAIN) {
    // Should be on main domain but currently on alternate domain
    shouldRedirect = true;
    redirectUrl = generateRedirectUrl(DEST_MAIN);
  }
  
  if (shouldRedirect) {
    console.log("[PRT] Redirecting to:", redirectUrl);
    window.location.replace(redirectUrl);
  } else {
    console.log("[PRT] No redirect needed, staying on current domain");
  }
  }
  
} catch (error) {
  console.error("[PRT] Error:", error);
  // On error, don't redirect - stay on current domain
}

console.log("[PRT] Router execution completed");